/*
Aditya 09/20/2022 2698947782 Integrated UDW lookup in Search
Ashraf 12/01/2022 2698947782 changed url's for print custom window.

*/

import {createSlice} from '@reduxjs/toolkit';
import {httpPost, httpGet} from '../../../util/Rest';
import {fetchDownloadSuccess} from '../PreviewFileData';
const initialData = {
  udwlookupData: [],
  dropDownData: {},
  accountStatus: null,
  udwlookupisLoading: false,
  lookupUDWerrorMsg: null,
  successMsg: null,
  lookupUDWstatus: null,
  WindowStatus: null,
  windowPrintStatus: null,
  errormessage: null,
  printCustomWindowsUrl: null,
  configurationUrl: '',
  dockey: '',
};

const slice = createSlice({
  name: 'udwLookup',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.udwlookupisLoading = true;
      state.lookupUDWerrorMsg = null;
      state.successMsg = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postUDWlookup: (state, action) => {
      state.udwlookupData = action.payload.response;
      state.udwlookupisLoading = false;
      state.lookupUDWstatus = action.payload.status;
      state.lookupUDWerrorMsg = null;
    },
    setCustomWindow: (state, action) => {
      // state.udwlookupisLoading = false;
      // state.lookupUDWerrorMsg = null;
      state.WindowStatus = action.payload.status;
      state.successMsg = action.payload.response;
    },
    fetchError: (state, action) => {
      state.lookupUDWerrorMsg = action.payload;
      state.isLoading = false;
    },
    resetError: (state, action) => {
      state.lookupUDWerrorMsg = null;
      state.udwlookupisLoading = false;
    },
    resetUDW: (state) => {
      state.udwlookupData = [];
      state.lookupUDWstatus = null;
    },
    resetUDWstatus: (state) => {
      state.lookupUDWstatus = null;
      state.WindowStatus = null;
    },
    resetPrintCustomWindowsStatus: (state) => {
      state.WindowStatus = null;
      state.udwlookupisLoading = false;
      state.lookupUDWerrorMsg = null;
      state.successMsg = null;
    },
    setConfigUrl: (state, action) => {
      state.isLoading = false;
      state.configurationUrl = action.payload;
    },
    resetConfigUrl: (state, action) => {
      state.configurationUrl = '';
    },
    resetDockey: (state, action) => {
      state.dockey = '';
    },
    setDockey: (state, action) => {
      state.isLoading = false;
      state.dockey = action.payload;
    },
  },
});

export default slice.reducer;

// Actions

export const {
  postUDWlookup,
  fetchError,
  resetError,
  fetchStart,
  resetUDW,
  resetUDWstatus,
  setCustomWindow,
  resetPrintCustomWindowsStatus,
  fetchDropDownData,
  setConfigUrl,
  resetConfigUrl,
  setDockey,
  resetDockey,
} = slice.actions;

export const fetchUdwDropdown = (accountNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`udw/admin/get/all/window/lookupname`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchDropDownData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error && error.message ? error.message : ''));
      });
  };
};

export const postUDWlookupData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`udw/getlookupvalue`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postUDWlookup(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};
export const postCustomWindows = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`custom/window/print/customwindow`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postPrintWindows({dockey: data?.message}, data));
          dispatch(setDockey(data?.message));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};

export const postPrintWindows = (payload, postcustomwindowsdata) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`custom/window/generateurlprintcw`, payload)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          // dispatch(setCustomWindow(postcustomwindowsdata));
          // download(data.data);
          dispatch(setConfigUrl(data?.data || ''));
          dispatch(fetchDownloadSuccess(postcustomwindowsdata));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};
export const resetErrorMsg = () => {
  return (dispatch) => {
    dispatch(resetError());
  };
};
export const resetUDWdata = () => {
  return (dispatch) => {
    dispatch(resetUDW());
  };
};
export const resetStatus = () => {
  return (dispatch) => {
    dispatch(resetUDWstatus());
  };
};

export const resetUDWPrintStatus = () => {
  return (dispatch) => {
    dispatch(resetPrintCustomWindowsStatus());
  };
};
